<template>
  <section>
    <aRow class="action-list" :gutter="[0, 20]">
      <aCol :span="24">
        <aAlert
          class="f12"
          type="info"
          banner
          message="As seguintes ações serão realizadas antes de cancelar toda a venda:"
        />
      </aCol>
      <aCol
        v-for="(action, index) in cancelActions"
        :key="index"
        :span="24"
        class="item"
      >
        <aRow :gutter="5">
          <aCol :span="2">
            <a-icon
              v-if="!action.loading"
              :type="action.done ? 'check' : ''"
              :class="['box', { check: action.done }]"
            />

            <a-icon v-if="action.loading" type="loading" class="box" />
          </aCol>
          <aCol :span="22">
            <span v-html="action.text"></span>
          </aCol>
        </aRow>
      </aCol>
    </aRow>

    <div class="a-center mt-20">
      <aDivider class="mb-20" />
      <aPopconfirm
        title="Tem certeza que deseja continuar?"
        ok-text="Sim"
        placement="top"
        cancel-text="Não"
        @confirm="onConfirmCancelSale"
        :disabled="loadingSubmit"
      >
        <aButton
          type="danger"
          html-type="submit"
          :loading="loadingSubmit"
          :disabled="loadingSubmit"
        >
          {{ loadingSubmit ? "Cancelando, aguarde..." : "Cancelar Venda" }}
        </aButton>
      </aPopconfirm>
    </div>
    <!-- <pre> {{ cancelActions }} </pre> -->
  </section>
</template>

<script>
import formatThings from "@/mixins/general/formatThings";

export default {
  name: "ContractCancelModeModal",
  props: {
    tempContract: Object,
    contract: Object,
    allContractData: Object,
    cancelActions: Array,
    productHasFee: Boolean,
    cancellationMode: Boolean,
    salesAdditiveType: String,
    disableCancelSale: Boolean,
    totalFees: Number,
  },
  mixins: [formatThings],
  data() {
    return {
      eventsList: [],
      invoicesList: [],
      loadingSubmit: false,
      cancelActionsLoading: false,
      loadingCancelSpecificProducts: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.verifyEventsAndInvoices();
    }, 2000);
  },
  methods: {
    isEmptyOrInvalid(value) {
      return value == undefined || value == null || value == "";
    },
    onClickOpenEvent(eventId) {
      window.open(`/events/calendar?oid=${eventId}`, "_blank");
    },
    onClickOpenInvoice(invoiceId) {
      window.open(`/financial/invoices?oid=${invoiceId}`, "_blank");
    },
    verifyEventsAndInvoices() {
      this.eventsList = [];
      this.invoicesList = [];

      const eventIds = new Set();
      const invoiceIds = new Set();

      const contractedServices = JSON.parse(
        this.tempContract.contracted_services
      );

      if (contractedServices.includes("hotel")) {
        const hotels = JSON.parse(this.tempContract["hotel_rows"]);
        for (const hotel of hotels) {
          const eventId =
            this.tempContract[`contract_finances_hotel_${hotel.id}_event_id`];

          const invoiceId =
            this.tempContract[`contract_finances_hotel_${hotel.id}_invoice_id`];

          if (!this.isEmptyOrInvalid(eventId) && !eventIds.has(eventId)) {
            this.eventsList.push({
              product: "hotel",
              productId: hotel.id,
              id: eventId,
              supplier:
                this.tempContract[
                  `contract_finances_hotel_${hotel.id}_supplier`
                ],
            });
            eventIds.add(eventId);
          }

          if (!this.isEmptyOrInvalid(invoiceId) && !invoiceIds.has(invoiceId)) {
            this.invoicesList.push({
              product: "hotel",
              productId: hotel.id,
              id: invoiceId,
              supplier:
                this.tempContract[
                  `contract_finances_hotel_${hotel.id}_supplier`
                ],
            });
            invoiceIds.add(invoiceId);
          }
        }
      }

      if (contractedServices.includes("flight")) {
        const flights = JSON.parse(this.tempContract["flight_sections_rows"]);

        for (const flight of flights) {
          const eventId =
            this.tempContract[`contract_finances_flight_${flight.id}_event_id`];

          const invoiceId =
            this.tempContract[
              `contract_finances_flight_${flight.id}_invoice_id`
            ];

          if (!this.isEmptyOrInvalid(eventId) && !eventIds.has(eventId)) {
            this.eventsList.push({
              product: "flight",
              productId: flight.id,
              id: eventId,
              supplier:
                this.tempContract[
                  `contract_finances_flight_${flight.id}_supplier`
                ],
            });
            eventIds.add(eventId);
          }

          if (!this.isEmptyOrInvalid(invoiceId) && !invoiceIds.has(invoiceId)) {
            this.invoicesList.push({
              product: "flight",
              productId: flight.id,
              id: invoiceId,
              supplier:
                this.tempContract[
                  `contract_finances_flight_${flight.id}_supplier`
                ],
            });
            invoiceIds.add(invoiceId);
          }
        }
      }

      if (contractedServices.includes("service")) {
        const services = JSON.parse(this.tempContract["service_rows"]);
        for (const service of services) {
          const eventId =
            this.tempContract[
              `contract_finances_service_${service.id}_event_id`
            ];

          const invoiceId =
            this.tempContract[
              `contract_finances_service_${service.id}_invoice_id`
            ];

          if (!this.isEmptyOrInvalid(eventId) && !eventIds.has(eventId)) {
            this.eventsList.push({
              product: "service",
              productId: service.id,
              id: eventId,
              supplier:
                this.tempContract[
                  `contract_finances_service_${service.id}_supplier`
                ],
            });
            eventIds.add(eventId);
          }

          if (!this.isEmptyOrInvalid(invoiceId) && !invoiceIds.has(invoiceId)) {
            this.invoicesList.push({
              product: "service",
              productId: service.id,
              id: invoiceId,
              supplier:
                this.tempContract[
                  `contract_finances_service_${service.id}_supplier`
                ],
            });
            invoiceIds.add(invoiceId);
          }
        }
      }
    },
    async onConfirmCancelSale() {
      this.loadingSubmit = true;
      try {
        await this.processCancelActions();
        setTimeout(() => {
          this.$emit("onContractCancelModeFinish");
        }, 200);
      } catch (error) {
        console.error("Error canceling sale:", error);
        this.$message.error("Ocorreu um erro ao cancelar a venda.");
      } finally {
        this.loadingSubmit = false;
      }
    },
    async processCancelActions() {
      for (const action of this.cancelActions) {
        action.loading = true;
        try {
          if (action.action === "create-credit-letter") {
            const data = await this.createCreditLetter();
            if (data) {
              action.done = true;
            } else {
              break;
            }
          } else if (action.action === "create-note-contract") {
            await this.$http
              .post("/note/create", {
                module_id: this.tempContract.id,
                module: "contract",
                reason: "Apenas para Registrar",
                user_id: this.$store.state.userData.id,
                content: `Este contrato foi cancelado por <b>${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}</b> em Aditivo de Vendas.`,
              })
              .then(() => (action.done = true));
          } else if (action.action === "cancel-contract") {
            await this.$http
              .post("/contract/update", {
                id: this.tempContract.id,
                customer_id: this.tempContract.customer_id,
                company_id: this.tempContract.company_id,
                company_branch_id: this.tempContract.company_branch_id,
                id_infotera: this.tempContract.id_infotera,
                user: this.tempContract.user,
                company: this.tempContract.company,
                value: this.tempContract.value,
                contracted_services: this.tempContract.contracted_services,
                release_date: this.tempContract.release_date,
                status: "canceled",
                action: "cancel-contract",
                description: `<font class="user">${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}</font> cancelou o contrato  <font class="id">ID ${this.tempContract.id}</font>.`,
                modified_by: {
                  name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
                  id: this.$store.state.userData.id,
                },
              })
              .then(() => (action.done = true));
          } else if (action.action === "cancel-sale") {
            await this.$http
              .post("/sale/update-field", {
                id: this.tempContract.sale_id,
                field: "status",
                value: "Cancelado",
                action: "cancel-sale",
                module: "sale",
                description: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} cancelou a venda #${this.tempContract.sale_id}.`,
                modified_by: {
                  name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
                  id: this.$store.state.userData.id,
                },
              })
              .then(() => (action.done = true));
          }
        } catch (error) {
          this.$message.error(`Erro ao executar ação: ${action.action}`);
          // action.done remains false if error
          break; // Stop further actions if any error occurs
        } finally {
          action.loading = false;
        }
      }
    },
    formatCreditLetterProductType() {
      if (this.tempContract.package_type === "Pacote Completo Terceiros") {
        return "Pacote Completo";
      } else {
        const contractedServices = JSON.parse(
          this.tempContract.contracted_services
        );
        contractedServices;
      }
    },
    async createCreditLetter() {
      this.loadingSubmit = true;

      try {
        const { data } = await this.$http.post(`/credit-letter/create`, {
          user_id: this.$store.state.userData.id,
          company_id: this.tempContract.company_id,
          company_branch_id: this.tempContract.company_branch_id,
          customer_id: this.tempContract.customer_id,
          issuer_id: this.$store.state.userData.id,
          supplier_id: 0,
          voyage_id: 0,
          product_type: this.formatCreditLetterProductType(),
          currency: "brl",
          value: this.allContractData?.total - this.totalFees,
          profit_value: 0,
          available_value: this.allContractData?.total - this.totalFees,
          spent_value: 0,
          status: "Ativo",
          supplier_status: "",
          supplier_value: 0,
          miles_status: 0,
          expires_at: "",
          receipt_date: "",
        });

        this.$message.success("Carta de crédito criada com sucesso!");

        await this.$http.post("/log/create", {
          user_id: this.$store.state.userData.id,
          module_id: this.tempContract.id,
          module: "contract",
          action: "cancel-mode-update-travelers-locator",
          description: `<b>[ADITIVO DE VENDAS]</b> ${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} criou uma nova carta de crédito ID ${data.id}.`,
        });

        await this.$http.post("/log/create", {
          user_id: this.$store.state.userData.id,
          module_id: data.id,
          module: "credit-letter",
          action: "create",
          description: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} criou uma nova carta de crédito ID ${data.id}.`,
        });

        return data;
      } catch (error) {
        console.error("Error creating credit letter:", error);
        this.$message.error("Ocorreu um erro ao criar a carta de crédito.");
        return false;
      } finally {
        this.loadingSubmit = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.action-list {
  color: #333;
  font-weight: 500;
  font-size: 13px;
  .item {
    .box {
      font-size: 13px;
      position: relative;
      top: -2px;
      border: 2px solid #ddd;
      width: 22px;
      height: 22px;
      line-height: 24px;
      border-radius: 5px;
    }

    .check {
      color: #00aa21;
      background: #e8ffec;
    }
  }
}
</style>